import { Roles, SettingsSubCategories } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import OktaSuccess from '../../components/OktaSuccess/OktaSuccess';

export const OktaSuccessRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: SettingsSubCategories.AUTHORIZE, role: Roles.EDITOR });

    return <LogicalRoute {...props} component={OktaSuccess} disabled={disabled} />;
};
